/**
 * The range spreads a dropdown offers.
 *
 * The four widths companies actually use, so the screens never invite 7.5% or
 * 12.3%. But a spread can be set to any whole percentage from 0 to 50 through
 * the API and through Iconic, and a dropdown whose value is not among its
 * options silently shows its first one: a company on ± 12% would read ± 10%.
 * So the spread in force is always offered too, in its place in the order.
 */
export const SPREADS = [10, 15, 20, 25]

export function spreadChoices(current?: number): number[] {
  if (current === undefined || !Number.isFinite(current) || SPREADS.includes(current)) return SPREADS
  return [...SPREADS, current].sort((a, b) => a - b)
}
